import { useMemo } from 'react';
import { useAppSelector } from '../../../app/hooks';
import {
  RanchPageViewEnum,
  selectRanchPageView,
} from '../../ranches/ranchesSlice';
import {
  RanchViewFeaturesEnum,
  selectCurrRanchViewFeature,
} from '../../select/selectSlice';

/**
 * Returns a boolean of whether the current view is the ranch summary table.
 * @returns {boolean} isRanchSummaryTable - Whether the current view is the ranch summary table
 */
export const useIsRanchSummaryTable = () => {
  const ranchPageView = useAppSelector(selectRanchPageView);
  const currRanchViewFeature = useAppSelector(selectCurrRanchViewFeature);

  const isRanchSummaryTable = useMemo(() => {
    return (
      ranchPageView === RanchPageViewEnum.ranchSummary &&
      currRanchViewFeature === RanchViewFeaturesEnum.Tables
    );
  }, [ranchPageView, currRanchViewFeature]);

  return isRanchSummaryTable;
};
